/* Example of use: /invoices/{invoiceId} => invoice with attachment */
/* This components + attachment-viewer.hbs will display attachment */
module.exports = Em.Component.extend({
    layoutName: 'components/attachment-viewer',
    classNames: ['attachment-viewer'],

    attachments: null
})
